import React from "react";

import VideosSection from "../../components/VideoSection/VideoSection";
import { developerVideos } from "../../helpers/videos";

export default function HowToDevelopers() {
  return <VideosSection videos={developerVideos} />;
}
